import React from 'react';
import cx from 'classnames';
import stylesheet from './Popover.css';

export type PopoverHeaderProps = {
  children?: React.ReactNode;
  className?: string;
};

const PopoverHeader = ({
  children,
  className,
  ...rest
}: PopoverHeaderProps) => {
  return (
    <div className={cx(stylesheet.header, className)} {...rest}>
      <h1 className={stylesheet.title}>{children}</h1>
    </div>
  );
};

export default PopoverHeader;
